import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/Users/anthony/Projects/blog/src/components/blog-post-layout.js";
const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = DefaultLayout;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)} components={components}>

      <MDXTag name="p" components={components}>{`After tinkering with Gatsby but not quite diving in deep, the `}<MDXTag name="a" components={components} parentName="p" props={{
          "href": "https://www.gatsbyjs.org/blog/100days/,",
          "title": "Gatsby challenge"
        }}>{`Gatsby 100 days of code challenge`}</MDXTag>{` came up. It seemed a good time to get stuck in.`}</MDXTag>
      <MDXTag name="p" components={components}>{`I had a site working but not published. Just not following the 'release early, release often' idea.`}</MDXTag>
      <MDXTag name="p" components={components}>{`I have a few things I would like to get out of the challenge. So I have a bit of a roadmap`}</MDXTag>
      <MDXTag name="ul" components={components}>
        <MDXTag name="li" components={components} parentName="ul">{`Launch a blog`}</MDXTag>
        <MDXTag name="li" components={components} parentName="ul">{`pagination`}</MDXTag>
        <MDXTag name="li" components={components} parentName="ul">{`categories`}</MDXTag>
        <MDXTag name="li" components={components} parentName="ul">{`plugin - strava?`}</MDXTag>
        <MDXTag name="li" components={components} parentName="ul">{`theme`}</MDXTag>
      </MDXTag>
           </MDXTag>;
  }

}
export const _frontmatter = {};
    